'use client';

// 방에서 ✕ 를 눌렀을 때 돌아갈 조이쌤 경로.
//
// history.back() 을 쓰면 안 된다. iframe 안 마이룸이 이동할 때마다(게스트 방 -> 연동 ->
// 약관 -> ...) 브라우저 히스토리에 항목이 쌓여서, back() 이 조이쌤 페이지가 아니라
// iframe 을 한 칸씩 되감는다. 실제로 가입 경로에서는 ✕ 를 6번 눌러야 빠져나왔다.
// 그래서 들어온 경로를 진입 시점에 적어두고 나갈 때 그리로 바로 이동한다.

const KEY = 'myroom_return_path';

export function rememberReturnPath(path?: string): void {
    if (typeof window === 'undefined') return;
    const p = path ?? window.location.pathname + window.location.search;
    try {
        sessionStorage.setItem(KEY, p);
    } catch {
        // 사파리 프라이빗 등 저장 실패는 무시 — 폴백(/home)으로 나간다.
    }
}

export function readReturnPath(): string | null {
    if (typeof window === 'undefined') return null;
    try {
        const p = sessionStorage.getItem(KEY);
        // 방 자신을 가리키면 무한 왕복이 되므로 버린다.
        return p && !p.startsWith('/myroom') ? p : null;
    } catch {
        return null;
    }
}
